import { CREATED, ACCEPTED, REJECTED, STATUS_MAP, STATUS_COLORS, STATUS_LABEL_KEYS } from "constants/reports";

export function getStatusLabel(t, status) {
  return t(STATUS_LABEL_KEYS[status] || status);
}

export function getStatusColor(status) {
  return STATUS_COLORS[status] || "#999999";
}

export function groupByStatus(items, field = "count") {
  return [CREATED, ACCEPTED, REJECTED].reduce((acc, status) => {
    acc[status] = items
      .filter((p) => STATUS_MAP[p.status] === status || p.status === status)
      .reduce((sum, p) => sum + (p[field] || 0), 0);
    return acc;
  }, {});
}